import React from 'react';

export default function EngineRecordsPage() {
  return (
    <div>
      <h2>Engine Records</h2>
      <p>This is where you’ll see all recorded engine‐performance data.</p>
    </div>
  );
}
